import React, { useState } from "react";
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import axios from "axios";

const AdminObserverAddModal = ({
  setModalVisible,
  visible,
  addUser
}) => {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = (event) => {
    event.preventDefault();
    setErrorMessage(null);
    axios
      .post("/api/admin/users/add-observer", {
        email,
        fullName,
      })
      .then((response) => {
        addUser({
          ...response.data,
        });
        setModalVisible(false);
        setFullName("");
        setEmail("");
      })
      .catch((error) => {
        setErrorMessage(error.response.data.message);
      });
  };

  const handleCancel = () => {
    setErrorMessage(null);
    setModalVisible(false);
    setFullName("");
    setEmail("");
  };

  return (
      <Modal isOpen={visible}>
        <ModalHeader>Dodaj managera</ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <Label>Imię i nazwisko obserwatora</Label>
              <Input
                name="fullName"
                type="text"
                onChange={(event) => setFullName(event.target.value)}
              />
            </FormGroup>
            <FormGroup>
              <Label>Email obserwatora</Label>
              <Input
                name="email"
                type="text"
                onChange={(event) => setEmail(event.target.value)}
              />
            </FormGroup>
            {errorMessage && (
              <FormGroup>
                <span style={{ color: "red" }}>{errorMessage}</span>
              </FormGroup>
            )}
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" outline onClick={handleCancel}>
            Anuluj
          </Button>
          <Button onClick={handleSubmit}>Dodaj</Button>
        </ModalFooter>
      </Modal>
  );
};

export default AdminObserverAddModal;
